import React from 'react';
import { motion } from 'framer-motion';
const bonos = [{
  num: '01',
  title: 'EMPEZÁ TU E-COM DESDE CERO',
  desc: 'La hoja de ruta de 5 pasos para arrancar sin trabarte',
  value: '$15.000'
}, {
  num: '02',
  title: 'CTAS QUE HACEN COMPRAR',
  desc: '50 llamadas a la acción listas para cerrar ventas en Reels',
  value: '$12.000'
}, {
  num: '03',
  title: 'TU PRIMER REEL QUE VENDE',
  desc: 'La checklist completa de la idea a la publicación sin errores',
  value: '$10.000'
}, {
  num: '04',
  title: '30 IDEAS PARA PUBLICAR Y VENDER',
  desc: 'Banco de ideas listas con hook, estructura y CTA incluidos',
  value: '$12.000'
}, {
  num: '05',
  title: 'CREÁ UNA OFERTA QUE SE ENTIENDA Y SE COMPRE',
  desc: 'La fórmula para comunicar tu producto en 1 frase',
  value: '$10.000'
}, {
  num: '06',
  title: 'GRABÁ REELS SIN MIEDO',
  desc: '7 métodos para grabar sin bloqueos aunque no quieras aparecer en cámara',
  value: '$10.000'
}];
export function BonosTable() {
  return <section className="w-full py-14 px-4 bg-base" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <h2 className="text-4xl md:text-5xl font-extrabold text-text-main flex items-center justify-center gap-4" data-id="element-20">
            <span data-id="element-21">🎁</span> 6 BONOS INCLUIDOS SIEMPRE
          </h2>
        </div>

        <div className="bg-alt rounded-3xl border border-primary/30 overflow-hidden shadow-2xl shadow-primary/5" data-id="element-22">
          <div className="hidden md:grid grid-cols-12 gap-4 p-6 border-b border-primary/20 text-text-muted font-semibold text-sm uppercase tracking-wider" data-id="element-23">
            <div className="col-span-1" data-id="element-24">#</div>
            <div className="col-span-8" data-id="element-25">Bono</div>
            <div className="col-span-3 text-right" data-id="element-26">Valor</div>
          </div>

          <div className="divide-y divide-primary/10" data-id="element-27">
            {bonos.map((bono, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="grid grid-cols-1 md:grid-cols-12 gap-4 p-6 items-center hover:bg-primary/5 transition-colors" data-id="element-28">
                <div className="col-span-1 hidden md:flex" data-id="element-29">
                  <div className="w-10 h-10 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold border border-primary/30" data-id="element-30">
                    {bono.num}
                  </div>
                </div>

                <div className="col-span-1 md:hidden mb-2" data-id="element-31">
                  <div className="inline-flex w-8 h-8 rounded-full bg-primary/20 text-primary items-center justify-center font-bold border border-primary/30 text-sm" data-id="element-32">
                    {bono.num}
                  </div>
                </div>

                <div className="col-span-1 md:col-span-8" data-id="element-33">
                  <h4 className="text-lg font-bold text-text-main mb-1" data-id="element-34">
                    {bono.title}
                  </h4>
                  <p className="text-text-muted text-sm" data-id="element-35">{bono.desc}</p>
                </div>

                <div className="col-span-1 md:col-span-3 flex md:flex-col items-center md:items-end justify-between md:justify-center mt-4 md:mt-0" data-id="element-36">
                  <span className="text-text-muted line-through text-sm" data-id="element-37">
                    {bono.value}
                  </span>
                  <span className="bg-cta/20 text-cta font-bold px-3 py-1 rounded-full text-sm mt-1 border border-cta/30" data-id="element-38">
                    GRATIS
                  </span>
                </div>
              </motion.div>)}
          </div>

          <div className="bg-primary/10 p-8 text-center border-t border-primary/30" data-id="element-39">
            <p className="text-xl md:text-2xl font-bold text-text-main" data-id="element-40">
              Valor total bonos:{' '}
              <span className="line-through text-text-muted mx-2" data-id="element-41">
                $69.000 ARS
              </span>
              <span className="text-cta ml-2" data-id="element-42">→ GRATIS con tu Kit</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}